import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const YouTubeIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M19.969 15.226a2.808 2.808 0 001.982-1.982c.467-1.748.469-5.397.469-5.397s0-3.648-.469-5.396A2.808 2.808 0 0019.97.469C18.22 0 11.209 0 11.209 0S4.2 0 2.452.469A2.807 2.807 0 00.469 2.45C0 4.199 0 7.847 0 7.847s0 3.649.469 5.397a2.808 2.808 0 001.982 1.982c1.748.469 8.759.469 8.759.469s7.011 0 8.759-.47zM14.79 7.847L8.966 4.484v6.726l5.824-3.363z"
                clipRule="evenodd"
            ></path>
        </svg>
    </IconWrapper>
)
